import React from "react";
import "./TestimonyModal.css";

interface TestimonyModalProps {
  open: boolean;
  onClose: () => void;
  username: string;
  subtitle: string;
  desc: string;
}

const TestimonyModal: React.FC<TestimonyModalProps> = ({
  open,
  onClose,
  username,
  subtitle,
  desc,
}) => {
  if (!open) return null;
  return (
    <div className="testimony-modal-backdrop" onClick={onClose}>
      <div className="testimony-modal" onClick={(e) => e.stopPropagation()}>
        <button className="testimony-modal-close" onClick={onClose}>
          ×
        </button>
        <div className="testimony-modal-username">{username}</div>
        <div className="testimony-modal-subtitle">{subtitle}</div>
        <div className="testimony-modal-desc">{desc}</div>
      </div>
    </div>
  );
};

export default TestimonyModal;
